// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Questions Page Styles */
.questions-header {
    margin-bottom: 2rem;
  }
  
  .stat-card-small {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 1.5rem;
    display: flex;
    align-items: center;
    transition: box-shadow 0.3s ease;
  }
  
  .stat-card-small:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .stat-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #f8f9fa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
  }
  
  .stat-icon i {
    font-size: 1.5rem;
  }
  
  .stat-number {
    font-size: 1.8rem;
    font-weight: bold;
    color: #333;
    line-height: 1;
  }
  
  .stat-label {
    color: #6c757d;
    font-size: 0.9rem;
    margin-top: 0.25rem;
  }
  
  /* Search and Filter Controls */
  .questions-controls {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 1.5rem;
    margin-bottom: 2rem;
  }
  
  .search-box {
    position: relative;
  }
  
  .search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
    z-index: 2;
  }
  
  .search-box .form-control {
    padding-left: 40px;
  }
  
  /* Question Cards */
  .question-card-item {
    margin-bottom: 1rem;
  }
  
  .question-card-hover {
    transition: all 0.3s ease;
    border: 1px solid #e9ecef;
  }
  
  .question-card-hover:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
  
  .question-badges .badge {
    font-size: 0.75rem;
  }
  
  .question-title {
    color: #333;
    font-weight: 500;
    line-height: 1.4;
  }
  
  .question-date {
    min-width: 120px;
    text-align: right;
  }
  
  .answer-preview {
    background-color: #f8f9fa;
    border-radius: 6px;
    padding: 0.75rem;
    margin-top: 0.75rem;
  }
  
  .no-answer-preview {
    margin-top: 0.75rem;
  }
  
  /* Question Detail Page */
  .question-detail {
    max-width: 900px;
  }
  
  .question-header {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 2rem;
  }
  
  .question-meta .badge {
    font-size: 0.8rem;
  }
  
  .question-title {
    color: #333;
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 1.4;
    margin-bottom: 1rem;
  }
  
  .question-info {
    margin-top: 1rem;
  }
  
  .question-card,
  .answer-card {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .question-card .card-header,
  .answer-card .card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
  }
  
  .answer-content {
    line-height: 1.6;
    color: #333;
  }
  
  .answer-attribution {
    margin-top: 1rem;
  }
  
  .instructor-avatar {
    width: 50px;
    height: 50px;
    background-color: #1e3a5f;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
  }
  
  .instructor-name {
    color: #333;
    font-size: 1rem;
  }
  
  .instructor-title {
    font-size: 0.9rem;
  }
  
  .no-answer {
    background-color: #f8f9fa;
    border-radius: 8px;
    margin: 1rem 0;
  }
  
  /* Modal Styles */
  .modal-content {
    border-radius: 12px;
    border: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  }
  
  .modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    border-radius: 12px 12px 0 0;
  }
  
  .modal-title {
    font-weight: 600;
  }
  
  .form-label {
    font-weight: 500;
    color: #333;
  }
  
  .form-control:focus,
  .form-select:focus {
    border-color: #b8860b;
    box-shadow: 0 0 0 0.2rem rgba(184, 134, 11, 0.25);
  }
  
  .alert-info {
    background-color: #e7f3ff;
    border-color: #b8daff;
    color: #004085;
  }
  
  /* Empty State */
  .empty-state {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 3rem;
  }
  
  /* Action Buttons */
  .question-actions {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 1.5rem;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .questions-controls {
      padding: 1rem;
    }
  
    .questions-controls .row {
      gap: 1rem;
    }
  
    .question-header {
      padding: 1.5rem;
    }
  
    .question-title {
      font-size: 1.3rem;
    }
  
    .question-date {
      min-width: auto;
      text-align: left;
      margin-top: 0.5rem;
    }
  
    .stat-card-small {
      padding: 1rem;
      margin-bottom: 1rem;
    }
  
    .stat-icon {
      width: 40px;
      height: 40px;
      margin-right: 0.75rem;
    }
  
    .stat-icon i {
      font-size: 1.2rem;
    }
  
    .stat-number {
      font-size: 1.5rem;
    }
  }
  
  @media (max-width: 576px) {
    .question-card-hover .card-body {
      padding: 1rem;
    }
  
    .question-badges {
      margin-bottom: 0.75rem;
    }
  
    .question-badges .badge {
      font-size: 0.7rem;
      margin-bottom: 0.25rem;
    }
  
    .modal-dialog {
      margin: 1rem;
    }
  
    .instructor-avatar {
      width: 40px;
      height: 40px;
      font-size: 1rem;
    }
  }
  
  /* Loading States */
  .spinner-border-sm {
    width: 1rem;
    height: 1rem;
  }
  
  /* Button Hover Effects */
  .btn-outline-secondary:hover,
  .btn-outline-success:hover {
    transform: translateY(-1px);
  }
  
  /* Card Animations */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .question-card-item {
    animation: fadeIn 0.3s ease-out;
  }
  `, "",{"version":3,"sources":["webpack://./src/questions.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,+BAA+B;EAC/B;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA,mBAAmB;EACnB;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,yCAAyC;IACzC,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA;;IAEE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;IACnB,YAAY;IACZ,0CAA0C;EAC5C;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,qBAAqB;IACrB,iDAAiD;EACnD;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;EACf;;EAEA,mBAAmB;EACnB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE;MACE,aAAa;IACf;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,qBAAqB;IACvB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;EACF;;EAEA,mBAAmB;EACnB;IACE,WAAW;IACX,YAAY;EACd;;EAEA,yBAAyB;EACzB;;IAEE,2BAA2B;EAC7B;;EAEA,oBAAoB;EACpB;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,+BAA+B;EACjC","sourcesContent":["/* Questions Page Styles */\n.questions-header {\n    margin-bottom: 2rem;\n  }\n  \n  .stat-card-small {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 1.5rem;\n    display: flex;\n    align-items: center;\n    transition: box-shadow 0.3s ease;\n  }\n  \n  .stat-card-small:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .stat-icon {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background-color: #f8f9fa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 1rem;\n  }\n  \n  .stat-icon i {\n    font-size: 1.5rem;\n  }\n  \n  .stat-number {\n    font-size: 1.8rem;\n    font-weight: bold;\n    color: #333;\n    line-height: 1;\n  }\n  \n  .stat-label {\n    color: #6c757d;\n    font-size: 0.9rem;\n    margin-top: 0.25rem;\n  }\n  \n  /* Search and Filter Controls */\n  .questions-controls {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 1.5rem;\n    margin-bottom: 2rem;\n  }\n  \n  .search-box {\n    position: relative;\n  }\n  \n  .search-icon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #6c757d;\n    z-index: 2;\n  }\n  \n  .search-box .form-control {\n    padding-left: 40px;\n  }\n  \n  /* Question Cards */\n  .question-card-item {\n    margin-bottom: 1rem;\n  }\n  \n  .question-card-hover {\n    transition: all 0.3s ease;\n    border: 1px solid #e9ecef;\n  }\n  \n  .question-card-hover:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    transform: translateY(-2px);\n  }\n  \n  .question-badges .badge {\n    font-size: 0.75rem;\n  }\n  \n  .question-title {\n    color: #333;\n    font-weight: 500;\n    line-height: 1.4;\n  }\n  \n  .question-date {\n    min-width: 120px;\n    text-align: right;\n  }\n  \n  .answer-preview {\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    padding: 0.75rem;\n    margin-top: 0.75rem;\n  }\n  \n  .no-answer-preview {\n    margin-top: 0.75rem;\n  }\n  \n  /* Question Detail Page */\n  .question-detail {\n    max-width: 900px;\n  }\n  \n  .question-header {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 2rem;\n  }\n  \n  .question-meta .badge {\n    font-size: 0.8rem;\n  }\n  \n  .question-title {\n    color: #333;\n    font-weight: 600;\n    font-size: 1.5rem;\n    line-height: 1.4;\n    margin-bottom: 1rem;\n  }\n  \n  .question-info {\n    margin-top: 1rem;\n  }\n  \n  .question-card,\n  .answer-card {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .question-card .card-header,\n  .answer-card .card-header {\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #e9ecef;\n  }\n  \n  .answer-content {\n    line-height: 1.6;\n    color: #333;\n  }\n  \n  .answer-attribution {\n    margin-top: 1rem;\n  }\n  \n  .instructor-avatar {\n    width: 50px;\n    height: 50px;\n    background-color: #1e3a5f;\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.2rem;\n  }\n  \n  .instructor-name {\n    color: #333;\n    font-size: 1rem;\n  }\n  \n  .instructor-title {\n    font-size: 0.9rem;\n  }\n  \n  .no-answer {\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    margin: 1rem 0;\n  }\n  \n  /* Modal Styles */\n  .modal-content {\n    border-radius: 12px;\n    border: none;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  }\n  \n  .modal-header {\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #e9ecef;\n    border-radius: 12px 12px 0 0;\n  }\n  \n  .modal-title {\n    font-weight: 600;\n  }\n  \n  .form-label {\n    font-weight: 500;\n    color: #333;\n  }\n  \n  .form-control:focus,\n  .form-select:focus {\n    border-color: #b8860b;\n    box-shadow: 0 0 0 0.2rem rgba(184, 134, 11, 0.25);\n  }\n  \n  .alert-info {\n    background-color: #e7f3ff;\n    border-color: #b8daff;\n    color: #004085;\n  }\n  \n  /* Empty State */\n  .empty-state {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 3rem;\n  }\n  \n  /* Action Buttons */\n  .question-actions {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 1.5rem;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .questions-controls {\n      padding: 1rem;\n    }\n  \n    .questions-controls .row {\n      gap: 1rem;\n    }\n  \n    .question-header {\n      padding: 1.5rem;\n    }\n  \n    .question-title {\n      font-size: 1.3rem;\n    }\n  \n    .question-date {\n      min-width: auto;\n      text-align: left;\n      margin-top: 0.5rem;\n    }\n  \n    .stat-card-small {\n      padding: 1rem;\n      margin-bottom: 1rem;\n    }\n  \n    .stat-icon {\n      width: 40px;\n      height: 40px;\n      margin-right: 0.75rem;\n    }\n  \n    .stat-icon i {\n      font-size: 1.2rem;\n    }\n  \n    .stat-number {\n      font-size: 1.5rem;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .question-card-hover .card-body {\n      padding: 1rem;\n    }\n  \n    .question-badges {\n      margin-bottom: 0.75rem;\n    }\n  \n    .question-badges .badge {\n      font-size: 0.7rem;\n      margin-bottom: 0.25rem;\n    }\n  \n    .modal-dialog {\n      margin: 1rem;\n    }\n  \n    .instructor-avatar {\n      width: 40px;\n      height: 40px;\n      font-size: 1rem;\n    }\n  }\n  \n  /* Loading States */\n  .spinner-border-sm {\n    width: 1rem;\n    height: 1rem;\n  }\n  \n  /* Button Hover Effects */\n  .btn-outline-secondary:hover,\n  .btn-outline-success:hover {\n    transform: translateY(-1px);\n  }\n  \n  /* Card Animations */\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .question-card-item {\n    animation: fadeIn 0.3s ease-out;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
